export enum QuestionnaireStatus {
    None = 'NONE',
    Init = 'INIT',
    Sent = 'SENT',
    FilledIn = 'FILLED_IN',
    AskedChanges = 'ASKED_CHANGES',
}

export function getLocalizedQuestionnaireStatus(): Record<QuestionnaireStatus, string> {
    return {
        'NONE': $localize`:@@questionnaireStatus.none:Niet aangemaakt`,
        'INIT': $localize`:@@questionnaireStatus.init:Aangemaakt`,
        'SENT': $localize`:@@questionnaireStatus.sent:Verzonden`,
        'FILLED_IN': $localize`:@@questionnaireStatus.filledIn:Ingevuld`,
        'ASKED_CHANGES': $localize`:@@questionnaireStatus.askedChanges:Aanpassingen gevraagd`,
    };
}
